import { Cidade, Estado } from 'models/cidade-estado';

export class Pessoa {
  codigo: any;
  cpf = '';
  cpd = '';
  rg = '';
  orgexp = '';
  nome = '';
  email = '';
  dtNascimento = '';
  ddd = '';
  celular = '';
  cidade: Cidade;
  uf: Estado;
  vinculo: any;
  dadosCpd: {
    turno: string,
    campus: string,
    curso: string,
    anoSemestreRef: string,
    apoio: any, // TODO: qual o tipo desse param??
  };
  isInscrito:any;
}
